import React from 'react';
import { Message } from 'semantic-ui-react';

// Global Components
import MyTimesheetEntryDateLink from 'components/MyTimesheetEntryDateLink';
import MyTimesheetEntryDateValue from 'components/MyTimesheetEntryDateValue';
import MyTimesheetEntryWorkHoursValue from 'components/MyTimesheetEntryWorkHoursValue';

interface OwnProps {
    uuid?: string;
}

type Props = OwnProps;

const MyTimesheetEntriesErrorMessageListItem = ({
    uuid
}: Props): React.ReactElement | null => {
    if (!uuid) {
        return null;
    }
    return (
        <Message.Item>
            <MyTimesheetEntryDateLink myTimesheetEntryUuid={uuid}>
                <React.Fragment>
                    <MyTimesheetEntryDateValue myTimesheetEntryUuid={uuid} />
                    {', '}
                    <MyTimesheetEntryWorkHoursValue
                        myTimesheetEntryUuid={uuid}
                    />
                </React.Fragment>
            </MyTimesheetEntryDateLink>
        </Message.Item>
    );
};

export default MyTimesheetEntriesErrorMessageListItem;
